function throwError() {}
const server = throwError;

export default process.browser ? require("./share").default : server;
